import React from 'react'
import Button from '@Components/Buttons/Button'
import { tableCellSanitizer } from '@App/helpers/table-cell-sanitizer'
import { CatalogTransferView } from '@Entities/rightsholder/catalog-transfer-view'
import ReviewFilesList from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/ReviewStep/ReviewData/ReviewFilesList'

interface ReviewDetailsProps {
    currentTransfer: CatalogTransferView
    onDownloadWorkReport: () => void
    onDownloadFile: (catalogTransferMemberUploadId: number) => void
}

const ReviewDetails = ({ currentTransfer, onDownloadWorkReport, onDownloadFile }: ReviewDetailsProps) => {
    const formatDate = (value?: string) =>
        tableCellSanitizer(value ? new Date(value).toLocaleDateString('en-US') : null)
    const catalogType = currentTransfer.isPartialTransfer ? 'Partial' : 'Full'
    const submittingMember = currentTransfer.submittingMember
    const sourcePublisherNames = currentTransfer.sourcePublishers
        ?.map((publisher) => publisher.publisherName)
        .join(', ')
    const sourcePublisherNumbers = currentTransfer.sourcePublishers
        ?.map((publisher) => publisher.hfaPublisherNumber)
        .filter((number) => number)
        .join(', ')

    return (
        <section className="review-content">
            <section className="review-content">
                <div className="review-content-area">
                    <p>
                        <strong>Catalog Information</strong>
                    </p>
                    <p>
                        <strong>Writer(s)</strong>
                        <div>{currentTransfer.writerNames}</div>
                    </p>
                    <div className="review-content-item">
                        <p>
                            <strong>Details of Submitting Member</strong>
                        </p>
                        <div>Email: {tableCellSanitizer(submittingMember?.email)}</div>
                        <div>Member Name: {tableCellSanitizer(submittingMember?.publisherName)}</div>
                        <div>
                            Member's Publisher Account Number (P#):{' '}
                            {tableCellSanitizer(submittingMember?.hfaPublisherNumber)}
                        </div>
                    </div>
                    <div className="review-content-item">
                        <p>
                            <strong>Catalog to be Transferred</strong>
                        </p>
                        <div>Publisher Name: {tableCellSanitizer(sourcePublisherNames)}</div>
                        <div>P Number: {tableCellSanitizer(sourcePublisherNumbers)}</div>
                    </div>
                    <div className="review-content-item">
                        <p>
                            <strong>Transfer Details</strong>
                        </p>
                        <div>Catalog Type: {tableCellSanitizer(catalogType)}</div>
                    </div>
                    <div className="review-content-item">
                        <p>
                            <strong>Effective Date</strong>
                        </p>
                        <div>{formatDate(currentTransfer?.effectiveDate)}</div>
                    </div>
                </div>
                <div className="review-content-area">
                    <div className="ct-works-summary-header">
                        <p>
                            <strong>Works Summary</strong>
                        </p>
                        <Button mainColor type="secondary" onClick={onDownloadWorkReport}>
                            Download Work Report
                        </Button>
                    </div>
                    <div className="review-content-item">
                        <p>
                            <strong>Works being transferred</strong>
                        </p>
                        <div>{tableCellSanitizer(currentTransfer?.workCount)}</div>
                    </div>
                </div>
                <div className="review-content-area">
                    <div className="review-content-item">
                        <p>
                            <strong>Document(s) Attached</strong>
                        </p>
                        <div>
                            <ReviewFilesList
                                uploadedDocs={currentTransfer?.uploadedDocs ?? []}
                                onDownloadFile={onDownloadFile}
                            />
                        </div>
                    </div>
                    <div className="review-content-item">
                        <p>
                            <strong>Acquiring Publisher</strong>
                        </p>
                        <div>
                            Administrator Name: {tableCellSanitizer(currentTransfer?.targetPublisher?.publisherName)}
                        </div>
                        <div>
                            Administrator Publisher Number (P#):{' '}
                            {tableCellSanitizer(currentTransfer?.targetPublisher?.hfaPublisherNumber)}
                        </div>
                        <div>
                            Administrator IPI Number: {tableCellSanitizer(currentTransfer?.targetPublisher?.ipiNumber)}
                        </div>
                    </div>
                    <div className="review-content-item">
                        <p>
                            <strong>Writers</strong>
                        </p>
                        <div>{tableCellSanitizer(currentTransfer?.writerNames)}</div>
                    </div>
                    <div className="review-content-item">
                        <p>
                            <strong>Additional details</strong>
                        </p>
                        <div>{tableCellSanitizer(currentTransfer?.supplementalInformation)}</div>
                    </div>
                </div>
            </section>
        </section>
    )
}

export default ReviewDetails
